/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { reviewSocialProfileSuggestionDtoSchema } from "../reviewSocialProfileSuggestionDtoSchema";
import { socialProfileSuggestionItemResponseDtoSchema } from "../socialProfileSuggestionItemResponseDtoSchema";
import { z } from "zod/v4";

export const reviewSuggestionPathParamsSchema = z.object({
    "suggestionId": z.uuid()
    })

export const reviewSuggestionHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

export const reviewSuggestion200Schema = z.lazy(() => socialProfileSuggestionItemResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const reviewSuggestion401Schema = z.any()

/**
 * @description Suggestion or its contact not found
 */
export const reviewSuggestion404Schema = z.any()

/**
 * @description Suggestion is no longer pending
 */
export const reviewSuggestion409Schema = z.any()

export const reviewSuggestionMutationRequestSchema = z.lazy(() => reviewSocialProfileSuggestionDtoSchema)

export const reviewSuggestionMutationResponseSchema = z.lazy(() => reviewSuggestion200Schema)